const accessType = {
   privilege: 'PRIVILEGE',
   role: 'ROLE',
   public: 'PUBLIC',
};

export default accessType;
